<script lang="ts">
import { AppVehicleCardComponent } from "./app-vehicle-card.ts";
export default AppVehicleCardComponent;
</script>

<template>
    <div class="product__card c-product_card" v-if="isApproved" v-bind="$attrs">
        <div class="product__card-top">
            <h5 class="h5 product__card-name">
                {{ vehicleTileDto.brand?.name + " " + vehicleTileDto.model + " " + vehicleTileDto.finish }}
            </h5>
            <!-- <h5 class="h5">{{ vehicleDto.model }}</h5> -->
            <p class="fz-smaller product__card-model">
                {{ vehicleTileDto.motorisation }}
            </p>
            <div
                v-if="false"
                class="product__card-comparison tooltip__info"
                v-tippy="{
                    content: i18n.t('carCard.addForComparasion'),
                    interactive: true,
                }"
            >
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="isSelectedForComparison" />
                        <i>
                            <svg
                                class="sprite-icon comparison__icon"
                                width="20"
                                height="20"
                            >
                                <use xlink:href="/img/sprite.svg#compare"></use>
                            </svg>
                        </i>
                    </label>
                </div>
            </div>
        </div>
        <div class="product__card-picture" :class="{ 'arrow-hover': arrowHover }">
            <div class="product__card-overlay">
                <div
                    v-if="vehicleTileDto.thumbnail_image"
                    class="swiper-container slider__gallery product__card-slider"
                    v-app-gallery
                >
                    <div class="swiper-wrapper">
                        <div class="swiper-slide dflex">
                            <img
                                class="swiper-lazy"
                                :data-src="vehicleTileDto.thumbnail_image.href_small"
                                :style="{
                                    objectFit: 'cover',
                                    'background-color': '#f4f8fd',
                                }"
                            />
                            <div class="swiper-lazy-preloader"></div>
                        </div>
                    </div>
                </div>
                <router-link
                    :to="{
                        path: `/auth/vehicle-details/${vehicleTileDto.id}`,
                        query: {
                            ...filters,
                        },
                    }"
                    custom
                    v-slot="{ href, navigate }"
                >
                    <a
                        v-app-auth-required="{
                            role: 'dealer',
                            showLogin: !isAuthenticated,
                            disable: true /* TODO: vehicleDto.promotions === carLabel.specialDeal, */,
                        }"
                        :href="href"
                        class="button button--outline"
                        @click.prevent="
                            () =>
                                routeToCarDetails(
                                    navigate,
                                    true /* TODO: vehicleDto.promotions === carLabel.specialDeal, */,
                                )
                        "
                    >
                        <i18n-t keypath="carCard.viewDetails"></i18n-t>
                    </a>
                </router-link>

                <!-- <button
                    class="button button--outline"
                    @click="() => routeToCarGroup(carGroup)"
                >
                    <i18n-t keypath="carCard.viewSelection"></i18n-t>
                </button> -->
            </div>

            <button
                v-if="isApproved"
                class="add-favorite"
                type="button"
                @click="toggleFavorite"
                :class="{ active: vehicleTileDto.is_favorite }"
            >
                <svg class="sprite-icon add-favorite__icon" width="16" height="14">
                    <use xlink:href="/img/sprite.svg#heart-fill"></use>
                </svg>
            </button>
            <div
                class="product__card-mark"
                v-for="promotion in promotionDtos"
                v-bind:key="promotion"
            >
                <div
                    class="mark__icon"
                    :style="{
                        backgroundImage: `url(/img/our-cars/${iconNameForPromotion(
                            promotion,
                        )}.svg)`,
                    }"
                ></div>
                <span class="mark__text">
                    {{ promotion?.name }}
                </span>
            </div>
        </div>
        <div class="product__card-bottom">
            <div class="product__card-price">
                <template v-if="!vehicleTileDto?.price_previous">
                    <div class="price">
                        <p class="h4">
                            <app-format-currency
                                :value="vehicleTileDto?.price_current?.list_price_euro"
                                :currency="currency"
                            ></app-format-currency>
                        </p>
                    </div>
                    <div class="price__bottom">
                        <span class="price__bottom-text">
                            <i18n-t keypath="carCard.excludeVAT"></i18n-t>
                        </span>
                    </div>
                </template>
                <div
                    class="price price__discount"
                    v-if="vehicleTileDto?.price_previous?.list_price_euro > 0"
                >
                    <p class="h4">
                        <app-format-currency
                            :value="vehicleTileDto?.price_current?.list_price_euro"
                            :currency="currency"
                        ></app-format-currency>
                    </p>
                    <div class="price__mark">
                        <img class="price__mark-bg" src="/img/red-mark.png" alt="" />
                        <span class="price__mark--minus">-</span>
                        <app-format-currency
                            :value="
                                vehicleTileDto.price_previous?.list_price_euro -
                                vehicleTileDto?.price_current?.list_price_euro
                            "
                            :options="{
                                maximumFractionDigits: 0,
                            }"
                            currency="EUR"
                        />
                    </div>
                </div>
                <div
                    class="price__bottom"
                    v-if="vehicleTileDto?.price_previous?.list_price_euro > 0"
                >
                    <span
                        class="fz-smaller price__bottom-num"
                        :class="{
                            'line-through':
                                vehicleTileDto?.price_previous?.list_price_euro >= 0,
                        }"
                    >
                        <app-format-currency
                            :value="vehicleTileDto?.price_previous?.list_price_euro"
                            :currency="currency"
                        ></app-format-currency>
                    </span>
                    <span class="price__bottom-text">
                        <i18n-t keypath="carCard.excludeVAT"></i18n-t>
                    </span>
                </div>
                <div v-if="vehicleTileDto.has_deal" class="special-offer">
                    <i18n-t keypath="carCard.specialOffer"></i18n-t>
                </div>
            </div>
            <div class="product__card-features">
                <div class="features__list">
                    <template v-if="vehicleTileDto.mileage">
                        <div
                            class="features__list-label tooltip__info"
                            v-tippy="{
                                content: i18n.t('carCard.kmUsed'),
                                interactive: true,
                            }"
                        >
                            <p class="features__list-text">
                                {{ vehicleTileDto.mileage }}
                                <b>KM</b>
                            </p>
                        </div>
                    </template>

                    <app-vehicle-options
                        :vehicle-id="vehicleTileDto.id"
                        :show-label="false"
                        :size="6"
                    />
                </div>
            </div>

            <div class="product__card-stock">
                <!-- <p
                    class="stock__label"
                    v-html="i18n.t('carCard.inStock', vehicleGroupDto.vehicle_counter)"
                ></p> -->

                <div
                    class="stock__color purple tooltip__info"
                    :class="[`--${vehicleTileDto.color?.name}`]"
                    v-tippy="{
                        content: vehicleTileDto.color?.name,
                        interactive: true,
                    }"
                    :style="{
                        backgroundColor: vehicleTileDto.color?.hex,
                        color: vehicleTileDto.color?.is_light ? 'black' : 'white',
                    }"
                ></div>
            </div>
        </div>
    </div>

    <div class="product__card not-login" v-else v-bind="$attrs">
        <div class="product__card-top">
            <h5 class="h5 product__card-name">
                {{ vehicleTileDto.brand?.name + " " + vehicleTileDto.model + " " + vehicleTileDto.finish }}
            </h5>
            <p class="fz-smaller product__card-model">
                {{ vehicleTileDto.motorisation }}
            </p>
            <div v-if="false" class="product__card-comparison tooltip__info">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model="isSelectedForComparison" />
                        <i>
                            <svg
                                class="sprite-icon comparison__icon"
                                width="20"
                                height="20"
                            >
                                <use xlink:href="/img/sprite.svg#compare"></use>
                            </svg>
                        </i>
                    </label>
                </div>
            </div>
        </div>
        <div class="product__card-picture" :class="{ 'arrow-hover': arrowHover }">
            <div class="product__card-overlay">
                <router-link
                    :to="{
                        path: `/auth/vehicle-details/${vehicleTileDto.id}`,
                        query: {
                            ...filters,
                        },
                    }"
                    custom
                    v-slot="{ href, navigate }"
                >
                    <a
                        v-app-auth-required="{
                            role: 'dealer',
                            showLogin: !isAuthenticated,
                            disable: true /* TODO: vehicleDto.label === carLabel.specialDeal, */,
                        }"
                        :href="href"
                        class="button button--outline"
                        @click.prevent="
                            () =>
                                routeToCarDetails(
                                    navigate,
                                    true /* vehicleDto.label === carLabel.specialDeal, */,
                                )
                        "
                    >
                        <i18n-t keypath="carCard.viewDetails"></i18n-t>
                    </a>
                </router-link>

                <!-- <button
                    class="button button--outline"
                    @click="() => routeToCarGroup(carGroup)"
                >
                    <i18n-t keypath="carCard.viewSelection"></i18n-t>
                </button> -->
            </div>
            <div
                class="product__card-mark"
                v-for="promotion in promotionDtos"
                v-bind:key="promotion"
            >
                <div
                    class="mark__icon"
                    :style="{
                        backgroundImage: `url(/img/our-cars/${iconNameForPromotion(
                            promotion,
                        )}.svg)`,
                    }"
                ></div>
                <span class="mark__text">
                    {{ promotion?.name }}
                </span>
            </div>
            <button
                v-if="isApproved"
                class="add-favorite"
                type="button"
                @click="toggleFavorite"
                :class="{ active: vehicleTileDto.is_favorite }"
            >
                <svg class="sprite-icon add-favorite__icon" width="16" height="14">
                    <use xlink:href="/img/sprite.svg#heart-fill"></use>
                </svg>
            </button>
            <img
                class="product__image"
                v-if="vehicleTileDto.thumbnail_image"
                :src="vehicleTileDto.thumbnail_image.href_small"
                :style="{ 'background-color': '#f4f8fd' }"
            />
        </div>
        <div class="product__card-bottom">
            <div class="product__card-price" v-if="vehicleTileDto.pricing">
                <template>
                    <div class="price">
                        <p class="h4">
                            <app-format-currency
                                :value="vehicleTileDto.pricing.list_price_euro"
                                :currency="currency"
                            ></app-format-currency>
                        </p>
                    </div>
                    <div class="price__bottom">
                        <span class="price__bottom-text">
                            <i18n-t keypath="carCard.excludeVAT"></i18n-t>
                        </span>
                    </div>
                </template>
                <div
                    class="price price__discount"
                    v-if="vehicleTileDto.pricing.discount_euro > 0"
                >
                    <p class="h4">
                        <app-format-currency
                            :value="vehicleTileDto.pricing.discount_euro"
                            :currency="currency"
                        ></app-format-currency>
                    </p>
                    <div class="price__mark">
                        <img class="price__mark-bg" src="/img/red-mark.png" alt="" />
                        <span class="price__mark--minus">-</span>
                        <span>{{ vehicleTileDto.pricing.discount_percentage }}</span>
                        <span class="price__mark--percent">%</span>
                    </div>
                </div>
                <div
                    class="price__bottom"
                    v-if="vehicleTileDto.pricing.discount_euro > 0"
                >
                    <span
                        class="fz-smaller price__bottom-num"
                        :class="{
                            'line-through': vehicleTileDto.pricing.list_price_euro,
                        }"
                    >
                        <app-format-currency
                            :value="vehicleTileDto.pricing.price_after_discount_euro"
                            :currency="currency"
                        ></app-format-currency>
                    </span>
                    <span class="price__bottom-text">
                        <i18n-t keypath="carCard.excludeVAT"></i18n-t>
                    </span>
                </div>
            </div>
            <div class="product__card-features">
                <div class="features__list">
                    <template v-if="vehicleTileDto.mileage">
                        <div
                            class="features__list-label tooltip__info"
                            v-tippy="{
                                content: i18n.t('carCard.kmUsed'),
                                interactive: true,
                            }"
                        >
                            <p class="features__list-text">
                                {{ vehicleTileDto.mileage }}
                                <b>KM</b>
                            </p>
                        </div>
                    </template>

                    <app-vehicle-options
                        :vehicle-id="vehicleTileDto.id"
                        :show-label="false"
                        :size="6"
                    />
                </div>
            </div>

            <div class="product__card-stock">
                <!-- <p
                    class="stock__label"
                    v-html="i18n.t('carCard.inStock', 1)"
                ></p> -->

                <div
                    class="stock__color purple tooltip__info"
                    :class="[`--${vehicleTileDto.color?.name}`]"
                    v-tippy="{
                        content: vehicleTileDto.color?.name,
                        interactive: true,
                    }"
                    :style="{
                        backgroundColor: vehicleTileDto.color?.hex,
                        color: vehicleTileDto.color?.is_light ? 'black' : 'white',
                    }"
                >
                    {{ 1 }}
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.special-offer {
    background-color: #FAB42D;
    color: white;
    padding: 5px 10px;
    width: fit-content;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    margin: 10px 0;
}
</style>